<template>
    <div class="event-header" v-if="season">
        <div class="event-header-top">
            <div class="event-header-titles">
                <div class="a-eyebrow">{{ season_label }}</div>
                <h1 class="a-page-title">{{ season.name }}</h1>
                <div class="event-header-meta">
                    <span class="a-pill" :class="status.cls">{{ status.label }}</span>
                    <span class="a-muted"><i class="bi bi-calendar3 me-1"></i>{{ range }}</span>
                    <span class="a-muted" v-if="season.join_code">Código <span class="a-mono">{{ season.join_code }}</span></span>
                </div>
            </div>
            <div class="event-header-actions">
                <slot name="actions"></slot>
                <button type="button" class="btn btn-secondary" @click="$refs.qr.open(season)"><i class="bi bi-qr-code"></i>Acceso</button>
            </div>
        </div>
        <nav class="a-tabs event-header-tabs">
            <router-link :to="{ name: 'Stages', params: { season_id: season.id } }" :class="{ active: ['Stages', 'StageRundown'].includes($route.name) }">
                Etapas <span class="a-count">{{ counts.stages }}</span>
            </router-link>
            <router-link :to="{ name: 'RankingsAdmin', params: { season_id: season.id } }">
                Rankings <span class="a-count">{{ counts.rankings }}</span>
            </router-link>
            <router-link :to="{ name: 'EventParticipants', params: { season_id: season.id } }">
                Participantes <span class="a-count">{{ counts.participants }}</span>
            </router-link>
            <router-link :to="{ name: 'EventSettings', params: { season_id: season.id } }">Configuración</router-link>
        </nav>
        <EventQrModal ref="qr" />
    </div>
</template>

<script>
import utils from '@/../../shared/utils'
import EventQrModal from '@/components/admin/EventQrModal.vue'
import { season_status, format_range } from '@/utils/admin-format'

// Top of every screen inside one event: what event, its state, how people
// get in, and the tabs to move between its parts.
export default {
    name: 'EventHeader',
    components: { EventQrModal },
    props: {
        season: { type: Object, default: null },
    },
    computed: {
        season_label(){
            return utils.get_season_label(window.MODE);
        },
        status(){
            return season_status(this.season);
        },
        range(){
            return format_range(this.season.start_date, this.season.end_date);
        },
        counts(){
            const game = this.$store.state.game;
            return {
                stages: (game.stages || []).filter((s) => s.season_id == this.season.id).length,
                rankings: (game.rankings || []).filter((r) => r.season_id == this.season.id).length,
                participants: (game.season_users || []).filter((su) => su.season_id == this.season.id).length,
            };
        }
    }
}
</script>

<style scoped>
.event-header{ margin-bottom: 24px; }
.event-header-top{
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 16px;
}
.event-header-titles{ min-width: 0; }
.event-header-meta{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px 16px;
    margin-top: 8px;
    font-size: 0.85rem;
}
.event-header-actions{ display: flex; gap: 8px; flex-wrap: wrap; }
</style>
